import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import NavBar from '../components/navbar/NavBar';
import * as menuTypes from '../redux/types/menu/menu-action-types';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    height: '100vh'
  },
  title: {
    flexGrow: 1
  }
}));

const ClassMissionsGameLayout: React.FC = (props: any) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <NavBar menuType={menuTypes.teacherMenu} />
      {props.children}
    </div>
  );
};

export default ClassMissionsGameLayout;
